import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { format } from "date-fns";
import { ICONS } from "../constants/constants";


const TASK_CATEGORIES = [
  "Inputs",
  "Irrigation",
  "Land Prep",
  "Harvesting",
  "Weeding",
  "Spraying",
  "Inspection",
];

const EditTaskModal = ({ show, handleClose, task, schedualerId, productList, onSave }) => {
  const [editedTask, setEditedTask] = useState({
    task_category: "",
    task_description: "",
    assigned_date: "",
    due_date: "",
    products: [],
  });

  useEffect(() => {
    if (task) {
      const cloned = {
        ...task,
        products: task.products || [],
      };
      setEditedTask(cloned);
    }
  }, [task]);

  useEffect(() => {
  if (task) {
    const cloned = {
      ...task,
      products: task.products || [],
      assigned_date: task.assigned_date ? new Date(task.assigned_date) : null,
      due_date: task.due_date ? new Date(task.due_date) : null,
    };
    setEditedTask(cloned);
  }
}, [task]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedTask = { ...editedTask, [name]: value };

    // Reset products if task category changes
    if (name === "task_category") {
      if (value === "Inputs" && (!updatedTask.products || updatedTask.products.length === 0)) {
        updatedTask.products = [{ productId: "", quantityPerAcre: "" }];
      } else if (value !== "Inputs") {
        updatedTask.products = [];
      }
    }

    setEditedTask(updatedTask);
  };

  const handleProductChange = (index, name, value) => {
  const updatedProducts = editedTask.products.map((product, i) =>
    i === index ? { ...product, [name]: value } : product
  );

  setEditedTask({ ...editedTask, products: updatedProducts });
};


  const handleAddProduct = () => {
    setEditedTask({
      ...editedTask,
      products: [...editedTask.products, { productId: "", quantityPerAcre: "" }],
    });
  };

  const handleRemoveProduct = (index) => {
    const updated = editedTask.products.filter((_, i) => i !== index);
    setEditedTask({ ...editedTask, products: updated });
  };

 const handleSubmit = () => {
  const formattedTask = {
    ...editedTask,
   
   due_date: task.due_date ? format(task.due_date, "MM-dd") : "",
   assigned_date: task.assigned_date ? format(task.assigned_date, "MM-dd") : "",
  };

  if (onSave) onSave(formattedTask);
};


  if (!task) return null;

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Edit Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Task Category</Form.Label>
                <Form.Select
                  name="task_category"
                  value={editedTask.task_category}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  {TASK_CATEGORIES.map((cat, idx) => (
                    <option key={idx} value={cat}>
                      {cat}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Task Description</Form.Label>
                <Form.Control
                  type="text"
                  name="task_description"
                  value={editedTask.task_description}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* <Row className="mt-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Start Date (MM-DD)</Form.Label>
                <Form.Control
                  type="text"
                  name="assigned_date"
                  value={editedTask.assigned_date}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>End Date (MM-DD)</Form.Label>
                <Form.Control
                  type="text"
                  name="due_date"
                  value={editedTask.due_date}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row> */}

          <Row className="mt-3">
  <Col md={6}>
    <Form.Group>
      <Form.Label>Start Date (MM-DD)</Form.Label>
      <div className="date-picker-container position-relative">
        <DatePicker
          selected={editedTask.assigned_date}
          onChange={(date) => setEditedTask({ ...editedTask, assigned_date: date })}
          dateFormat="MM-dd"
          placeholderText="MM-DD"
          className="form-control"
          // showMonthDropdown
          // showYearDropdown
          yearDropdownItemNumber={50}
          scrollableYearDropdown

          // ✅ custom header for arrows
  renderCustomHeader={({
    date,
    decreaseMonth,
    increaseMonth,
    decreaseYear,
    increaseYear,
  }) => (
    <div className="d-flex justify-content-between align-items-center px-2">
      
      {/* Year arrows */}
      <button type="button" onClick={decreaseYear} className="btn btn-sm">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">{date.getFullYear()}</span>

      <button type="button" onClick={increaseYear} className="btn btn-sm">
        <FaChevronRight />
      </button>

      {/* Month arrows */}
      <button type="button" onClick={decreaseMonth} className="btn btn-sm ms-3">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">
        {date.toLocaleString("default", { month: "long" })}
      </span>

      <button type="button" onClick={increaseMonth} className="btn btn-sm">
        <FaChevronRight />
      </button>
    </div>
  )}
        />
        <img src={ICONS.calenderIcon} className="calendar-icon" alt="Calender" />
      </div>
    </Form.Group>
  </Col>

  <Col md={6}>
    <Form.Group>
      <Form.Label>End Date (MM-DD)</Form.Label>
      <div className="date-picker-container position-relative">
        <DatePicker
          selected={editedTask.due_date}
          onChange={(date) => setEditedTask({ ...editedTask, due_date: date })}
          dateFormat="MM-dd"
          placeholderText="MM-DD"
          className="form-control"
          // showMonthDropdown
          // showYearDropdown
          yearDropdownItemNumber={50}
          scrollableYearDropdown

          // ✅ custom header for arrows
  renderCustomHeader={({
    date,
    decreaseMonth,
    increaseMonth,
    decreaseYear,
    increaseYear,
  }) => (
    <div className="d-flex justify-content-between align-items-center px-2">
      
      {/* Year arrows */}
      <button type="button" onClick={decreaseYear} className="btn btn-sm">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">{date.getFullYear()}</span>

      <button type="button" onClick={increaseYear} className="btn btn-sm">
        <FaChevronRight />
      </button>

      {/* Month arrows */}
      <button type="button" onClick={decreaseMonth} className="btn btn-sm ms-3">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">
        {date.toLocaleString("default", { month: "long" })}
      </span>

      <button type="button" onClick={increaseMonth} className="btn btn-sm">
        <FaChevronRight />
      </button>
    </div>
  )}
        />
       <img src={ICONS.calenderIcon} className="calendar-icon" alt="Calender" />
      </div>
    </Form.Group>
  </Col>
</Row>


          {editedTask.task_category === "Inputs" && (
            <div className="mt-4">
              <h6>Products</h6>
              {editedTask.products.map((product, index) => (
                <Row key={index} className="mb-2">
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>Product</Form.Label>
                      <Form.Select
                        value={product.productId}
                        onChange={(e) =>
                          handleProductChange(index, "productId", e.target.value)
                        }
                      >
                        <option value="">Select</option>
                        {productList?.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.productName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>Quantity per Acre</Form.Label>
                      <Form.Control
                        type="number"
                        value={product.quantityPerAcre}
                        onChange={(e) =>
                          handleProductChange(index, "quantityPerAcre", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    {index > 0 && (
                      <Button
                        className="underline-text p-0 border-0 bg-transparent"
                        onClick={() => handleRemoveProduct(index)}
                      >
                        Remove
                      </Button>
                    )}
                  </Col>
                </Row>
              ))}
              {/* <Button variant="link" onClick={handleAddProduct}>
                + Add Product
              </Button> */}
               <Button className="add-task p-0 border-0 mb-3" onClick={handleAddProduct}>
                              
                 <span className="fs-3 m-0 pt-1">+</span><span className="underline-text">Add Product</span>
                              
                              </Button>
            </div>
          )}
        </Form>

        <div className="text-center mt-4">
          <Button className="button px-5" onClick={handleSubmit}>
            Save Changes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditTaskModal;
